import PropTypes from "prop-types";
import CustomImage from "../../atoms/customImage";

/**
 *
 * @returns
 */
const BlankSpaceUI = ({ classes }) => {
  return (
    <div className={`flex w-full items-center justify-center ${classes}`}>
      <CustomImage
        src="/icons/lockation-lock-footer-image.png"
        width={540}
        height={165}
        sizes="100%"
        alt="blank space"
      />
    </div>
  );
};
BlankSpaceUI.propTypes = {
  classes: PropTypes.string,
};
export default BlankSpaceUI;
